export const numberWithSpaces = (value?: number | string) => {
  if (value === null || value === undefined || value === '') return '';

  const num = typeof value === 'string' ? Number(value.replace(',', '.')) : value;

  if (isNaN(num)) return '';

  return new Intl.NumberFormat('ru-RU').format(num);
};

export const compareBankCommissions = (a: BankCommissions, b: BankCommissions) => {
  if (!a.id || !b.id) {
    return -1;
  }

  return a.id > b.id ? 1 : -1;
}

export const formatHSCode = (code: string) => {
  if (!code) return '';
  return code.replace(/^(\d{4})(\d{2})(\d{3})(\d)$/, "$1 $2 $3 $4");
}

export const capitalizeFirst = (text?: string, locale?: string) => {
  if (!text) return text;
  return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
};

export const CALCULATION_VIEW_MODE_ERROR = 'CALCULATION_VIEW_MODE';
export const CALCULATION_VIEW_MODE_ERROR_STATUS = 'CUSTOM_ERROR';

export const isCalculationViewModeError = (
  result: unknown
): boolean => {
  if (!result || typeof result !== 'object' || !('error' in result)) {
    return false;
  }

  const mutationResult = result as CalculationViewModeMutationResult & CalculationViewModeError;
  const error = mutationResult.status ? mutationResult : mutationResult.error;

  return error?.error === CALCULATION_VIEW_MODE_ERROR
    && error.status === CALCULATION_VIEW_MODE_ERROR_STATUS;
};
